export const scrollConfig = {
  bar: {
    background: '#ccc'
  }
}
